"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MaximumRecordsReachedDialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _personalProductListEditContext = require("../../../../contexts/personalProductListEditContext");
var _useTranslations = require("../../../../hooks/useTranslations");
var _jsxRuntime = require("react/jsx-runtime");
const MaximumRecordsReachedDialog = ()=>{
    const { setIsMaximumRecordsReached, maximumAllowedPersonalProductLists, isMaximumRecordsReached } = (0, _personalProductListEditContext.usePersonalProductListEditContext)();
    const { translations, formatMessage } = (0, _useTranslations.useTranslations)();
    const onMaxDialogClose = (0, _react.useCallback)(()=>{
        setIsMaximumRecordsReached(false);
    }, [
        setIsMaximumRecordsReached
    ]);
    const actions = (0, _react.useMemo)(()=>[
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
                color: "default",
                variant: "outlined",
                onClick: onMaxDialogClose,
                children: translations.maxListDlgBackBtn
            }, "back")
        ], [
        onMaxDialogClose,
        translations.maxListDlgBackBtn
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.FeedbackDialog, {
        hideCloseButton: true,
        severity: "error",
        open: isMaximumRecordsReached,
        header: translations.maxPublicDlgTitle,
        actions: actions,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
            children: formatMessage('maxPublicDlgText', {
                maxNumber: maximumAllowedPersonalProductLists
            })
        })
    });
};
exports.MaximumRecordsReachedDialog = MaximumRecordsReachedDialog;
